/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  updateList,
  id,
  updateBirthCertificate,
  getBirthCertificateSettings,
  showBirthCertificateSettings,
  history,
  updating,
}) {
  const [formData, setFormData] = useState({
    amount: '',
    computer_fee: '',
    is_active: '',
  });

  const commonValidation = {
    amount: 'required',
    computer_fee: 'required',
  };

  const validateForm = useFormValidator(formData, commonValidation);

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      amount: _.get(updateList, 'amount') || '',
      computer_fee: _.get(updateList, 'computer_fee') || '',
      is_active: _.get(updateList, 'is_active') ? 1 : 0,
    });
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData,
      amount: formData.amount.toUpperCase(),
      computer_fee: formData.computer_fee.toUpperCase(),
      is_active: _.get(formData, 'is_active') ? 1 : 0,
    };

    updateBirthCertificate(id, args, ({ data }) => {
      getBirthCertificateSettings();
      setModal({ isOpen: false });
      showBirthCertificateSettings(id);
      history.push(
        `/civil-registry/birth-certificate/settings/${_.get(data, 'id')}`
      );
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(updateList)) {
      OnSetFormData();
    }
  }, [updateList]);

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row m-1 p-1">
          <div className="col-12 form-group">
            <label htmlFor="amount" className="form-label mb-1">
              Amount &nbsp; {validateForm.renderMessage('amount')}
            </label>
            <input
              className="form-control text-uppercase"
              type="text"
              name="amount"
              onChange={onChange}
              value={_.get(formData, 'amount') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="amount" className="form-label mb-1">
              Computer Fee &nbsp; {validateForm.renderMessage('computer_fee')}
            </label>
            <input
              className="form-control text-uppercase"
              type="text"
              name="computer_fee"
              onChange={onChange}
              value={_.get(formData, 'computer_fee') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center">
          <button
            disabled={updating}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={updating}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  updateList: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  updateBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  getBirthCertificateSettings: PropTypes.instanceOf(Function).isRequired,
  showBirthCertificateSettings: PropTypes.instanceOf(Function).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  updating: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  updating: api.loading.indexOf(c.UPDATE_BIRTH_CERTIFICATE_SETTINGS) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
